// extracted by css-extract-rspack-plugin
export default {"widgetGalleryImage":"widget-gallery-image--mbTlsd72WvgAmCCE","widgetGalleryImageImage":"widget-gallery-image__image--ivZoFpTpnjgNjsSV"};